import { ReactNode } from 'react';
import { Logo } from '@/components/shared/Logo';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
}

export function AuthLayout({ children, title, description }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f4f4f3] p-4">
      <div className="w-full max-w-[580px] rounded-[24px] bg-white p-10">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>

        <h1 className="mb-2 text-center font-manrope text-[32px] font-bold leading-tight text-[#0d0d0d]">
          {title}
        </h1>

        {description && (
          <p className="mb-6 text-[14px] text-[#565858]">
            {description}
          </p>
        )}

        {children}
      </div>
    </div>
  );
}
